import { GridTypeEnum } from '@shared/utils/mappers/grid-mapper';
import { Icon } from '@types-custom/models/ui/icon-model';
import { MapEventTypeEnum } from '@types-custom/models/ui/map-viewer-model';

export const NameManagePanelMap: { [key: string]: string } = {
  [MapEventTypeEnum.SENSORS]:     'SENSORES',
  [MapEventTypeEnum.CAMERAS]:     'Cámaras',
  [MapEventTypeEnum.INCIDENTS]:   'Situación',
  [MapEventTypeEnum.PMV]:         'PANEL DE MENSAJERÍA',
  [MapEventTypeEnum.PMVconsulta]: 'PANEL DE CONSULTA',
  [MapEventTypeEnum.PMVEditar]:   'PANEL EDITAR',
};

export const IconManagePanelMap: {
  [key: string]: { icon: Icon; alt: string };
} = {
  [MapEventTypeEnum.SENSORS]: { icon: Icon.sensor_w, alt: 'icono sensores' },
  [MapEventTypeEnum.CAMERAS]: { icon: Icon.camera, alt: 'icono cámaras' },
  [MapEventTypeEnum.PMV]: { icon: Icon.pmv_w, alt: 'icono pmv' },
  [MapEventTypeEnum.INCIDENTS]: {
    icon: Icon.alert,
    alt: 'icono alerta incidentes',
  },
};

export const GridTypePanelManageMap: { [key: string]: GridTypeEnum } = {
  [MapEventTypeEnum.SENSORS]:     GridTypeEnum.ManageSensors,
  [MapEventTypeEnum.CAMERAS]:     GridTypeEnum.ManageCameras,
  [MapEventTypeEnum.PMV]:         GridTypeEnum.ManageVariableMessaging,
  [MapEventTypeEnum.INCIDENTS]:   GridTypeEnum.ManageIncidents,
  [MapEventTypeEnum.PMVconsulta]: GridTypeEnum.PMVconsulta,
};

export const TitlePanelGridMap: { [key: string]: string } = {
  [MapEventTypeEnum.PMV]: 'REGISTRO PANELES DE MENSAJERÍA',
};

export const TitleButtonCreateEditMap: { [key: string]: string } = {
  [MapEventTypeEnum.PMV]: 'PANEL',
};

export const TitlePanelFilterMap: { [key: string]: string } = {
  [MapEventTypeEnum.PMV]: 'FILTRO DE BÚSQUEDA',
};

export const TextManagePanelMap: { [key: string]: string } = {
  [MapEventTypeEnum.SENSORS]:   `Permite consultar la cantidad de puntos sensorizados en la ciudad, su ubicación y su actividad en las últimas 24 horas. Haga clic en un punto sobre el mapa para consultar la información.`,
  [MapEventTypeEnum.CAMERAS]:   `Permite agregar, editar y consultar la información de las cámaras de actores viales, LPR y CCTV registradas en el sistema.Haga clic en un punto sobre el mapa para consultar la información.`,
  [MapEventTypeEnum.PMV]:       `Permite agregar, editar y consultar la información del panel de mensajería en todos sus componentes. Haga clic en un punto sobre el mapa para agregar la localización.`,
  [MapEventTypeEnum.INCIDENTS]: `Permite agregar, editar y consultar la información relacionada con todas las novedades que se presentan en torno a la movilidad de la ciudad. Haga clic en un punto sobre el mapa para consultar la información.`,
};

export const MessageCreateSuccess: { [key: string]: (info?: any) => string } = {
  [MapEventTypeEnum.SENSORS]:  () =>  'El sensor se ha registrado con éxito',
  [MapEventTypeEnum.CAMERAS]:  () => 'La cámara se ha registrado con éxito',
  [MapEventTypeEnum.PMV]:      () => 'El panel se ha registrado con éxito',
  [MapEventTypeEnum.INCIDENTS]: (info?: any) => `La situación ID ${info?.id} creada con éxito`,
};

export const MessageEditSuccess: { [key: string]: (info?: any) => string } = {
  [MapEventTypeEnum.SENSORS]:   () => 'El sensor se ha editado con éxito',
  [MapEventTypeEnum.CAMERAS]:   () => 'La cámara se ha editado con éxito',
  [MapEventTypeEnum.PMV]:       () => 'El panel se ha editado con éxito',
  [MapEventTypeEnum.INCIDENTS]: (info?: any) => `La situación ID ${info?.id} se ha modificado con éxito`,
};

export const fileNameDownloaded: { [key: string]: string } = {
  [MapEventTypeEnum.SENSORS]:   'Lista de Sensores',
  [MapEventTypeEnum.CAMERAS]:   'Lista de Cámaras',
  [MapEventTypeEnum.PMV]:       'Lista de PMV',
  [MapEventTypeEnum.INCIDENTS]: 'Lista de Novedades Bitácora',
};
